/**
 * Store listeners setup for web app
 *
 * Only imports listeners that are relevant for web.
 * Mobile-specific listeners (Intercom, Pendo, native sync, etc.) are excluded.
 */

// Import listener infrastructure
export { listenerMiddleware, initListeners } from './listenerMiddleware';

// Import listeners (side effects)
import './pauthDetection'; // Detect first-time PAUTH_INVALID_TOKEN transitions
